import { Model } from "@vuex-orm/core";
import config from "../configs/Configuration";

export default class Configuration extends Model {
  static get entity() {
    return "configurations";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      settings: this.attr([]),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
